import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';

import ApplyNow from './apply/ApplyNow';
import ApplicantDetails from './apply/ApplicantDetails';
import FinancialVerificationPage from './apply/FinancialVerificationPage';
import ProcessApplication from './apply/ProcessApplication';
import RechargeSettings from './apply/RechargeSettings';
import StateRestrictedProducts from './apply/StateRestrictedProducts';
import BankCredentials from './purchase/BankCredentials';
import PhoneVerification from './purchase/PhoneVerification';
import PinVerification from './purchase/PinVerification';
import useSessionEntity from '../../hooks/useSessionEntity';
import Loading from '../shared/Loading';

export default function Apply({ match }) {
  const publicKey = useSelector((state) => state.sessions.get('public_key'));
  const isLoading = useSelector((state) => state.sessions.get('loading'));
  const application = useSessionEntity('application');

  if (!publicKey && !isLoading) {
    return <Redirect to="/invalid" />;
  }

  const isReady = (Component, routeProps) => {
    return application ? (
      <Component {...routeProps} />
    ) : (
      <Loading className="w-14 h-14" />
    );
  };

  return (
    <Switch>
      <Route
        path={`${match.path}/applicant_details`}
        render={(routeProps) => isReady(ApplicantDetails, routeProps)}
      />
      <Route
        path={`${match.path}/state_restricted_products`}
        render={(routeProps) => isReady(StateRestrictedProducts, routeProps)}
      />
      <Route
        path={`${match.path}/phone`}
        render={(routeProps) => isReady(PhoneVerification, routeProps)}
      />
      <Route
        path={`${match.path}/verify/:type/:contact/:confirm?`}
        render={(routeProps) => isReady(PinVerification, routeProps)}
      />
      <Route
        path={`${match.path}/phone_check`}
        render={(routeProps) => isReady(PhoneVerification, routeProps)}
      />
      <Route
        path={`${match.path}/verify_check/:type/:contact/:confirm?`}
        render={(routeProps) => isReady(PinVerification, routeProps)}
      />
      <Route
        path={`${match.path}/process_application`}
        render={(routeProps) => isReady(ProcessApplication, routeProps)}
      />
      <Route
        path={`${match.path}/require_bank_credentials`}
        component={BankCredentials}
      />
      <Route
        path={`${match.path}/recharge_settings`}
        component={RechargeSettings}
      />
      <Route
        path={`${match.path}/financial_verification`}
        render={(routeProps) => isReady(FinancialVerificationPage, routeProps)}
      />
      <Route
        path={`${match.path}/:merchant_public_key/:prequalification_id?`}
        component={ApplyNow}
      />
    </Switch>
  );
}
